import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { LoggerService, tryNormalizeHttpError } from '@spartacus/core';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { CustomInvoiceConnector } from '../../../connectors/custom-invoice.connector';
import { B2BDocumentTypeList } from '../../../invoices.model';
import {
  LOAD_INVOICES_DOCUMENT_TYPES,
  LoadInvoicesDocumentTypes,
  LoadInvoicesDocumentTypesFail,
  LoadInvoicesDocumentTypesSuccess
} from '../actions/custom-invoices-document-types.actions';

@Injectable()
export class CustomInvoicesDocumentTypesEffects {
  protected logger = inject(LoggerService);
  loadInvoicesDocumentTypes$: Observable<LoadInvoicesDocumentTypesSuccess | LoadInvoicesDocumentTypesFail> = createEffect(() =>
    this.actions$.pipe(
      ofType(LOAD_INVOICES_DOCUMENT_TYPES),
      map((actions: LoadInvoicesDocumentTypes) => actions),
      switchMap(() =>
        this.invoicesConnector.getDocumentTypes().pipe(
          map((documentTypes: B2BDocumentTypeList) => new LoadInvoicesDocumentTypesSuccess(documentTypes)),
          catchError((error: any) => of(new LoadInvoicesDocumentTypesFail(tryNormalizeHttpError(error, this.logger))))
        )
      )
    )
  );

  constructor(private actions$: Actions, private invoicesConnector: CustomInvoiceConnector) {}
}
